import { motion } from "motion/react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function EstateFridgeWrapper({ children }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: "100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{
        duration: 0.2,
      }}
      exit={{ opacity: 0, translateY: "100%" }}
      className="flex flex-col justify-center items-center gap-1 h-[100vh] w-full min-h-[37.5rem] tall:gap-10"
    >
      {children}
    </motion.div>
  );
}
